import { render, staticRenderFns } from "./CommentVideoCreator.vue?vue&type=template&id=28d7e2b8&scoped=true"
import script from "./CommentVideoCreator.vue?vue&type=script&lang=ts"
export * from "./CommentVideoCreator.vue?vue&type=script&lang=ts"
import style0 from "./CommentVideoCreator.vue?vue&type=style&index=0&id=28d7e2b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d7e2b8",
  null
  
)

export default component.exports